import GenericDialog from "./generic";
import { jobUpdateState } from "api/job";
import { JobStatusDropdown } from "models/dropdowns/jobStatus";
import { JobStatusIcon } from "providers/icons";
import { notifySimple } from "providers/toast";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import Radio from "widgets/shared/inputs/radio";

export type JOB_STATUS = "pending" | "completed" | "failed";

const JobStatusDialog = (props: {
  isOpen: boolean;
  id: string;
  status: JOB_STATUS;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const { isOpen, id, status, onClose, onSuccess } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [jobStatus, setJobStatus] = useState<JOB_STATUS>("pending");

  // Function for linking an user
  const doDqEdit = async () => {
    dispatch(setLoading(true));

    const { status } = await jobUpdateState({
      id: id,
      state: jobStatus,
    });
    dispatch(setLoading(false));
    if (status === 200) {
      onSuccess();
      notifySimple(t("notification.job.status.success"), "success");
    } else {
      notifySimple(t("notification.job.status.error"), "error");
    }
  };

  useEffect(() => {
    if (id && status) {
      setJobStatus(status);
    }
  }, [status]);

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.job.status.title")}
      onOk={doDqEdit}
      onClose={onClose}
      onExit={onClose}
      size="md"
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        {JobStatusDropdown &&
          JobStatusDropdown.map((item, index) => {
            const { statusIcon } = JobStatusIcon(item.label);
            return (
              <div
                className="flex items-center text-sm"
                key={`role-${index}`}
              >
                <Radio
                  labelKey={item.label}
                  checked={jobStatus === item.value}
                  onChange={() =>
                    setJobStatus(item.value as JOB_STATUS)
                  }
                  color="secondary"
                />
                <div className="flex items-center mx-2">
                  {statusIcon}
                </div>
              </div>
            );
          })}
      </div>
    </GenericDialog>
  );
};

export default JobStatusDialog;
